import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import { trimSpaces } from '../../../../utils/Util';
import ErrorAwareBankAccountField from '../../../common/inputfields/ErrorAwareBankAccountField';
import ErrorAwareNumberField from '../../../common/inputfields/ErrorAwareNumberField';
import ErrorAwareSelectField from '../../../common/inputfields/ErrorAwareSelectField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';

class NewTaxType extends Component {

    fields = ["publicId", "name", "paymentDay", "taxPaymentType", "bankAccountNumber"];

    state = {
        newAgain: false,
        publicId: '',
        name: '',
        bankAccountNumber: '',
        paymentDay: '',
        taxPaymentType: enums.taxTypes[0],
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            publicId: '',
            name: '',
            bankAccountNumber: '',
            paymentDay: '',
            taxPaymentType: enums.taxTypes[0],
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/taxType';
        const requestObject = {
            "publicId": this.state.publicId,
            "name": this.state.name,
            "bankAccountNumber": trimSpaces(this.state.bankAccountNumber),
            "paymentDay": this.state.paymentDay,
            "taxPaymentType": this.state.taxPaymentType.value,
        };
        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="publicId"
                            label="Adónem sorszáma"
                            errors={this.state.errors}
                            value={this.state.publicId}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Adónem megnevezése"
                            errors={this.state.errors}
                            value={this.state.name}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareBankAccountField
                            name="bankAccountNumber"
                            label="Bankszámlaszám"
                            errors={this.state.errors}
                            value={this.state.bankAccountNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            name="paymentDay"
                            label="Fizetési nap"
                            errors={this.state.errors}
                            value={this.state.paymentDay}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareSelectField
                            labelId="tax-type-label"
                            id="tax-type"
                            name="taxPaymentType"
                            label="Típus"
                            errors={this.state.errors}
                            value={this.state.taxPaymentType}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.taxTypes}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewTaxType);
